import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ChiSono from "@/pages/ChiSono";
import Aree from "@/pages/Aree";
import AreaDetail from "@/pages/AreaDetail";
import Consulenze from "@/pages/Consulenze";
import Supervisioni from "@/pages/Supervisioni";
import Webinar from "@/pages/Webinar";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Libri from "@/pages/Libri";
import Eventi from "@/pages/Eventi";
import Media from "@/pages/Media";
import Rete from "@/pages/Rete";
import ReteIscrizione from "@/pages/ReteIscrizione";
import ReteScheda from "@/pages/ReteScheda";
import Contatti from "@/pages/Contatti";
import QuandoNonSonoGiusta from "@/pages/QuandoNonSonoGiusta";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/chi-sono" element={<ChiSono />} />
        <Route path="/aree-di-competenza" element={<Aree />} />
        <Route path="/aree/:slug" element={<AreaDetail />} />
        <Route path="/consulenze" element={<Consulenze />} />
        <Route path="/supervisioni" element={<Supervisioni />} />
        <Route path="/webinar" element={<Webinar />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/libri" element={<Libri />} />
        <Route path="/pubblicazioni" element={<Libri />} />
        <Route path="/eventi" element={<Eventi />} />
        <Route path="/media" element={<Media />} />
        <Route path="/rete" element={<Rete />} />
        <Route path="/rete/iscriviti" element={<ReteIscrizione />} />
        <Route path="/rete/scheda/:id" element={<ReteScheda />} />
        <Route path="/contatti" element={<Contatti />} />
        <Route path="/quando-non-sono-la-persona-giusta" element={<QuandoNonSonoGiusta />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}
